export default "__VITE_ASSET__673ee92e__"